import { useState } from "react";
import { Table } from "react-bootstrap";
import { currencyFormat } from "../../../helpers/numericFields";
import styles from './AdvancePaymentDetails.module.css'
import { EditAdvancePayment } from "./EditAdvancePayment";
import { useDispatch } from 'react-redux';
import { groupReservationVoucher } from "../../../store/slices/groupFiles/thunks";
import { ModalPaymentImage } from "../../ui/controls/ModalPaymentImage";

export const AdvancePaymentDetails = ({ masterSaleGroup, code }) => {
  const dispatch = useDispatch();
  const [editAdvancePayment, setEditAddAdvancePayment] = useState(false);
  const [paymentSelected, setPaymentSelected] = useState({});
  const [viewImage, setViewImage] = useState(false);

  const edit2 = (payment) => {
    setEditAddAdvancePayment(true);
    setPaymentSelected(payment);
  }

  const viewImage2 = (payment) => {
    setViewImage(true);
    setPaymentSelected(payment);
  }

  const downloadGroupVoucher = (id) => {
    dispatch(groupReservationVoucher(id));
  }

  return (
    <div style={{ marginTop: 20, marginBottom: 50, border: "1 solid gray", background: "white", padding: 20 }}>
      <div className="table-responsive">
        <Table className="table border text-nowrap mg-b-0">
          <thead>
            <tr>
              <th>Pago #</th>
              <th>Fecha</th>
              <th>Aprobado</th>
              <th>Recibo</th>
              <th>Editar</th>
              <th>Agente</th>
              <th>Metodo</th>
              <th>Forma De Pago</th>
              <th>Referencia</th>
              <th>Comprobante</th>
              <th>Monto</th>
              <th>Notas</th>              
            </tr>
          </thead>
          <tbody>
            {
              masterSaleGroup.advancePayments.map((payment, index) => (
                <tr key={payment.id}>
                  <td>{index + 1}</td>
                  <td>{payment.date}</td>
                  <td style={{ textAlign: "center" }}>
                    {payment.approved === 1 ? <i className="fa fa-check" /> : ""}
                  </td>
                  <td style={{ textAlign: "center" }}>
                    {
                      payment.approved === 1
                        ? <i className={`fa fa-file-pdf-o ${styles.edit}`} onClick={() => downloadGroupVoucher(payment.id)}></i>
                        : null
                    }
                  </td>
                  <td style={{ textAlign: "center" }}>
                    <i className={`fe fe-edit ${styles.edit}`} onClick={() => edit2(payment)}></i>
                  </td>      
                  <td>{payment.agent}</td>
                  <td>{payment.paymentMethod}</td>
                  <td>{payment.paymentWay}</td>
                  <td>{payment.reference}</td>
                  <td style={{ textAlign: "center" }}>
                    {
                      payment.image === 1
                        ? <i className={`fa fa-image ${styles.edit}`} onClick={() => viewImage2(payment)}></i>
                        : null
                    }                    
                  </td>
                  <td>{currencyFormat(payment.amount)}</td>
                  <td>{payment.notes}</td>                             
                </tr>))
            }
          </tbody>
        </Table>
      </div>
      <EditAdvancePayment payment={paymentSelected} masterSaleGroup={masterSaleGroup}
        isOpen={editAdvancePayment} setIsOpen={setEditAddAdvancePayment} />
      <ModalPaymentImage code={code} id={paymentSelected.id} isOpen={viewImage} setIsOpen={setViewImage} />
      <div className={styles.total}>Total: {
        currencyFormat(masterSaleGroup.advancePayments.reduce((a, b) => (b.approved === 1) ? a += b.amount : a, 0))}
      </div>
    </div>
  )
}
